module.exports = __webpack_public_path__ + "img/hail.6ad58bce.svg";